import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { callLSQLapp, getLsqLeadBody, DataLayerEvent, setValuesInLocalStorange, encryptBody } from "../services/lsq.js";
import { formStartEvent, formIntermediateEvent, formSuccessEvent, formSubmissionFailEvent, formAbandonmentEvent, formFieldErrorEvent, ctaClickEvent } from "../services/adobeDataLayer.js";
import { useCookies } from "react-cookie";
import queryString from "query-string";
import { notifySuccess, notifyWarn, offersAlert } from "./Toastifyfn";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ReCAPTCHA from "react-google-recaptcha";

function Form() {
  let navigate = useNavigate();

  const [inputs, setInputs] = useState({});
  const [error, setErrors] = useState({});
  const [space, setSpace] = useState(false);
  const [spaceTwo, setSpaceTwo] = useState(false);
  const [checked, setChecked] = useState(false);
  const [mobileVal, setMobileval] = useState("");
  const [disableBtn, setDistablebtn] = useState(false);
  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");
  const [cookies, setCookie] = useCookies();
  const [otpsent, setOtpsent] = useState(false);
  const [token, setToken] = useState("");
  const [otpdisableBtn, setOtpBtn] = useState(false);
  const [btnDisable, setBtnDisable] = useState(true);
  const [PIN, setPIN] = useState("");
  const [cityName, setCityname] = useState("");
  const [citydefined, setCitydefined] = useState(false);
  const [disableApplyBtn, setApplyBtnDisable] = useState(false);
  const [OTP, setOTP] = useState("");
  const [modalShow, setModalShow] = React.useState(false);

  const [timerDisplay, setTimerDisplay] = useState("none");
  const [otpBtnText, setOtpBtnText] = useState("Resend OTP");
  const [resendBtnDisplay, hideDisplayBtn] = useState("initial");
  const [timer, setTimer] = useState(0);
  const [otpDisabled, setOtpDisabled] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState("");
  const [displayRecap, setDisplayRecap] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState("");

  const [eventFired, setEventFired] = useState({
    fullname: false,
    pan: false,
    email: false,
    mobile: false,
    otp: false,
    terms_chk: false,
    pincode: false,
    dob: false,
    applyNow: false
  });

  const hasTriggeredFormStart = useRef(false);
  let lastAccessedField = "na";

  let formIsValid = true;

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      //console.log("lead form started: ", hasTriggeredFormStart.current)
      // Custom logic to be executed before tab or window is closed
      if (hasTriggeredFormStart.current) {
        formAbandonmentEvent("Land Loan lead form", "lead generation", lastAccessedField, "details");
        //console.table(window.adobeDataLayer)
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    //Clean Up
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    []
  );
  useEffect(() => {
    if (mobileVal.length === 10 && otpsent) {
      timer > 0 && setTimeout(timeOutCallback, 1000);
    }
  }, [timer, timeOutCallback, mobileVal, otpsent]);

  const getUTMDetails = queryString.parse(window.location.search);
  // set Fbp, Fbc, UTM parameters values
  useEffect(() => {
    let fbpVal = cookies["_fbp"] === undefined ? "" : cookies["_fbp"];
    let fbcVal = cookies["_fbc"] === undefined ? "" : cookies["_fbc"];

    setFbp(fbpVal);
    setFbc(fbcVal);

    // set UTM parameters
    if (getUTMDetails.utm_source) {
      if (
        getUTMDetails.utm_source == "affiliate" ||
        getUTMDetails.utm_source.includes("affinity") == true
      ) {
        setDisplayRecap(true);
      }
    }
  }, []);

  inputs.FBClickID = fbc;
  inputs.FBPixelID = fbp;
  function onRecaptchaChange(value) {
    // console.log("Captcha value:", value);
    setRecaptchaValue(value);
    setRecaptchaError("");
  }
  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        dialogClassName="modal-70w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            TERMS AND CONDITIONS
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <b>DECLARATION</b> <br />
          I/We hereby confirm my/our interest in availing loan facility in the
          form of (i.e. Home Loan /Loan Against Property/Balance Transfer/Office
          Premises Loan/Top up)from ICICI Bank Limited (“ICICI Bank”) and in
          relation thereto I have applied for the loan facility by visiting the
          [www.icicibank.com] (“Website”) by submitting my application
          electronically.
          <br />
          <br />
          I/We hereby confirm that I/we have authorized the representative of
          ICICI Bank to enter the application details in the electronic
          application form on my/our behalf in accordance with the
          instructions/information given by me/us in the electronic application
          form."
          <br />
          <br />
          I/We have reviewed and verified the details entered by ICICI Bank’s
          representative in the electronic application form and declare the same
          to be true, correct and updated. I/We hereby confirm that and the
          electronic application form has been submitted by ICICI Bank’s
          representative post my/our review, verification and confirmation of
          the application details.",
          <br />
          <br />
          I/We confirm that the information submitted by me/us electronically
          and the details already available with ICICI Bank (if any) are true,
          correct, complete and up to date in all respects and that such
          information can be relied upon by ICICI Bank for the purpose of loan
          facility.
          <br />
          <br />
          I/we understand that the processing fee is a one-time non-refundable
          fee and is collected by ICICI Bank for the purpose of processing
          my/our loan facility request and such processing fee once paid, will
          not be refunded in any circumstances.
          <br />
          <br />
          I/We understand that the loan facility, if sanctioned, shall be
          subject to the customary terms and conditions as applicable to the
          product.
          <br />
          <br />
          I/We hereby authorize ICICI Bank to collect information/personal data
          from me and other agencies including Unique Identification authority
          of India (UIDAI), Credit information companies (CICs), and conduct
          verification/due diligence, make references and enquiries with the
          group companies, that ICICI Bank may deem fit, for the purpose of the
          loan facility.
          <br />
          <br />
          I/We understand that sanction of loan is at the sole discretion of
          ICICI Bank. ICICI Bank reserves the right to reject the application
          without assigning any reason and shall not held liable for such
          rejection. With respect to Instant loan, if any, ICICI Bank
          reserves the right at any time to withdraw the loan offer and/ or
          modify, alter the Instant loan, terms and conditions and / or
          ask for any additional document /information from customer. The loan
          facility will only be established/disbursed upon completion of
          definitive loan documents and other terms and conditions as ICICI Bank
          may reasonably require.
          <br />
          <br />
          I/We understand that the disbursement of funds under the sanction
          letter accepted by me/us is subject to completion of legal and
          technical analysis of the property to be mortgaged, to the
          satisfaction of ICICI Bank, wherein the title to the property can be
          ascertained to be clear and marketable.
          <br />
          <br />
          I/We hereby confirm that the there are no insolvency proceeding
          initiated against me/us nor I/we has ever been adjudicated insolvent /
          bankrupt
          <br />
          <br />
          I/We undertake to inform ICICI Bank / its agents regarding the change
          in the residential addresses to provide any further information that
          ICICI Bank may require.
          <br />
          <br />
          I/We hereby authorize ICICI Bank to exchange, share or part with all
          the information, data or document in relation to the loan application
          including but not limited to the credit repayment, history or default,
          if any, committed by the me/us to credit bureaus, agencies, statutory
          bodies, information utilities.
          <br />
          <br />
          Except to the extent disclosed to ICICI Bank herein, no Chairman /
          Managing Director or director or a relative/near relation of a
          Chairman / Managing Director or director of a banking company
          (including ICICI Bank and its subsidiaries) or mutual funds/venture
          capital funds or a relative/near relation of a senior officer of ICICI
          Bank, as specified by RBI, is: a partner of our concern, or a trustee,
          member, director, manager, employee of our concern, or of our
          subsidiary, or our holding company, or a guarantor on my/our behalf,
          or holds substantial interest in our concern or my/our subsidiary or
          holding company. For the purpose of this clause the terms “relative”,
          “near relation” & “senior officer” shall have the same meaning
          ascribed to them under the RBI master circular on Loans and Advances
          dated July 1, 2015, para 2.2.1.8 and shall include any amendments made
          thereto.
          <br />
          <br />
          I/We undertake to inform as to any change in my occupation/residential
          address. /mobile and to provide any further information/document that
          ICICI bank may require from time to time. In case of
          non-provision/non-updation of mobile number, I/We would not receive
          SMS alerts pertaining to the account and shall not hold ICICI Bank
          liable for the same.
          <br />
          <br />
          I/We acknowledge that ICICI Bank reserves the right to retain such
          documents submitted with this application and will not return the same
          to the me/us.
          <br />
          <br />
          I/We hereby declare and affirm that the I/we have not made any
          payments in cash.
          <br />
          <br />
          I/We hereby authorize ICICI Bank to store all information/data
          provided herein including personal and business information with
          ICICI group companies/other institutions/ such other persons as may
          be necessary/ required for the purpose of, including but not limited to,
          marketing, cross selling of various products and services etc to me/us,
          use or process the aforesaid information/data by such person/s, or
          furnishing of the processed information/ data/ products thereof to other
          Banks/Institutions/other persons as may be necessary, and we shall not hold
          ICICI Bank liable in connection with the use of such information or otherwise.
          <br />
          <br />
          I/We hereby authorize ICICI Bank to exchange, share or part with all
          information/data provided herein including personal and business information
          with ICICI group companies/other institutions/ such other persons as may be
          necessary/ required for the purpose of, including but not limited to, marketing,
          cross selling of various products and services etc to me/us, use or process the
          aforesaid information/data by such person/s, or furnishing of the processed
          information/data/products thereof to other Banks/Institutions/other persons as may be necessary,
          and we shall not hold ICICI Bank liable in connection with the use of such information or otherwise.
          <br />
          <br />
          I/We hereby declare that the information of GSTIN with respect to the number and
          billing address is correct and ICICI Bank can update the same in its records. I/We hereby
          declare that the information provided can be used by ICICI Bank for the purposes of charging
          GST and reporting of transactions on the GSTN portal and for other related aspects in relation
          to reporting as stated under GST Act and applicable rules in this regard.
          <br />
          <br />
          I/We may share, exchange or deliver instruction/information/document
          electronically to ICICI Bank through email. I/We acknowledge and
          understand that communication through e-mail cannot be guaranteed to
          be secured or error free and such information could be
          incomplete/unsafe and subject to tampering and unauthorized access and
          I/we shall not hold ICICI Bank responsible or liable for relying
          and/or acting on such instructions/document/information received
          through email.
          <br />
          <br />
          I/We hereby consent to receiving information from Central KYC Registry
          through SMS/Email on the registered number/email address
          <br />
          <br />
          I/We agree to receive update on various products and services related
          information and special offer from ICICI Bank/group companies and
          other entities via email alerts, or SMS alerts or phone call.
          <br />
          <br />
          <b>
            REVERSE SOLICITATION DECLARATIONS (APPLICABLE FOR NRI/OCI CUSTOMERS)
          </b>
          <br />
          <br />
          I/We hereby certify that I am/we are resident outside India who is/are
          either citizen of India or Person of Indian Origin (“Non-Resident
          Indian”) as defined under the Foreign Exchange Management Act, 1999 as
          amended, modified or updated from time to time.
          <br />
          <br />
          I/We confirm that I/we am/are interested in availing loan facility in
          the form of Home Loan /Loan Against Property/Balance Transfer/Office
          Premises Loan/Top up (“Facility”) from ICICI Bank Limited, India
          (“ICICI Bank”) and in this regard I/We hereby agree, acknowledge and
          confirm that:
          <br />
          <br />
          (a) I/we have voluntarily applied for the loan facility by visiting
          the [website]
          <br />
          <br />
          (b) The decision to avail the loan facility, through ICICI Bank’s
          website is my/our own independent decision, which has been considered
          after personal analysis and careful consideration of the risks,
          benefits, terms and conditions taking into account my/our investment
          objectives, financial situation and particular needs.
          <br />
          <br />
          (c) I/We hereby declare that ICICI Bank has not
          influenced/communicated/ solicited/ marketed about Facility and that
          I/we have sought the assistance of ICICI Bank without any liability
          for ICICI Bank. I/We shall not hold ICICI Bank liable or responsible
          in any manner whatsoever or make any claim against ICICI Bank or the
          regulators in Oman, Qatar, QFC, Singapore, UAE, DIFC, Bahrain or India
          in relation to the management or operations of the Facility.
          <br />
          <br />
          (d) There are/shall be no legal or regulatory prohibitions or
          impediments, as per the laws of my/our home country, against my/our
          maintaining my/our relationship with ICICI Bank, including availing
          the aforementioned Facility.
          <br />
          <br />
          (e) In availing the Facility, I/we shall ensure that I/we are in full
          compliance with all laws and regulations, including, without
          limitation, all applicable exchange control/taxation laws/regulations
          in my/our home/host country and I/ we am/ taking this decision based
          on my/ our analysis or legal counsel.
          <br />
          <br />
          (f) I/We shall obtain all necessary regulatory approvals, if required,
          in connection with availing the Facility and/ or entering into any
          such transactions and shall promptly make all necessary regulatory
          reporting, as and when required, to the relevant authorities in my/our
          home/host country or any other country of residence where I/we may
          relocate to in future and I/we agree to furnish to ICICI Bank, upon
          request, copies of the approvals/reports, if any
          <br />
          <br />
          (g) I/We are aware that the Facility availed by me/us may or may not
          be serviced by the offshore branches/representative
          offices/subsidiaries of ICICI Bank located outside India and shall
          further be subject to applicability of the applicable laws in such
          jurisdiction.
          <br />
          <br />
          (h) I/We shall indemnify and keep indemnified ICICI Bank, its
          affiliates, directors, representatives, employees and agents against
          any/ all direct, indirect, special, incidental or consequential
          losses, costs, expenses, suits, damages, whatsoever, which ICICI Bank,
          its affiliates, directors, representatives, employees and agents may
          suffer, pay or incur by reason of or in connection with arising out of
          the products/ services including the Facility including t that have
          been provided to me/us on my/ our specific request, including legal
          proceedings taken against ICICI Bank, its affiliates, directors,
          representatives, employees and agents.
          <br />
          <br />
          (i) I/We acknowledge that relying solely on my/our representations,
          warranties, undertakings and statements contained herein, ICICI Bank
          is agreeing to establish/continue its relationship with me/us and
          providing the Facility to me/us.
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // sending otp
  const sendOTPText = async (mobileNumber, option) => {
    // let mobileNumber = e.target.value;
    if (mobileNumber.length === 10 && mobileNumber.match(/^[6-9]\d{9}$/)) {
      let payload = { mobile: mobileNumber, messageType: "otpGeneral" };
      let param = { otp: "send", productType: "LL" };
      const otpResponse = await callLSQLapp(payload, "OTP", param);
      if (otpResponse.data.message.response.sent) {
        //Trigger AA Form Intermediate Event for OTP Receive
        if (option === "resend") {
          ctaClickEvent("otp:resend", "lead form", "button", 0, "na");
        } else {
          formIntermediateEvent("receive", "otp");
        }
        notifySuccess("OTP has been sent to your mobile number.");
        setDistablebtn(true);
        setOtpsent(true);
        setTimerDisplay("inline");
        setTimer(30);
      } else {
        notifyWarn("Please Resend OTP.");
        setDistablebtn(true);
        setTimerDisplay("none");
        setOtpsent(false);
      }

      setMobileval(mobileNumber);
    }
  };

  // verifyOTP
  const verifyOTPText = async (mobileNum, otpValue) => {
    let payload = { mobile: mobileNum, otp: otpValue };
    let param = { otp: "verify", productType: "LL" };
    let currentErrors = { ...error };
    const otpVerifyResponse = await callLSQLapp(payload, "OTP", param);
    if (
      otpVerifyResponse.data.message === "Failure Occured, please check logs"
    ) {
      currentErrors['otp'] = 'Invalid OTP entered.';
      notifyWarn("Invalid OTP");
      setOTP("");
      setErrors(currentErrors);
      // setResendBtn(true);
      return;
    }
    const tokenValue =
      otpVerifyResponse.data.message.response.dataSent.UniqueID;

    setToken(tokenValue);
    inputs.otp = otpValue;
    // setResendBtn(false);
    setDistablebtn(true);
    setOtpBtn(true);
    setBtnDisable(false);
    setTimer(0);
    setOtpDisabled(true);
    hideDisplayBtn("initial");
    setOtpBtnText("Verified");
    //Trigger AA Form Intermediate Event for OTP Verify
    formIntermediateEvent("verified", "otp");
    notifySuccess("OTP Verified Successfully.");
  };

  useEffect(() => {
    let mobileVal = inputs["mobile"];
    if (mobileVal !== undefined) {
      if (mobileVal.length === 10 && otpsent === false) {
        sendOTPText(mobileVal);
      }

      if (mobileVal.length !== 10) {
        setOtpsent(false);
      }
      if (OTP.length === 6 && mobileVal.length === 10 && token === "") {
        // console.log("verifying num", { OTP, mobileVal });
        verifyOTPText(mobileVal, OTP);
      }
    }
  }, [OTP, token, inputs["otp"], inputs["mobile"]]);


  // Date
  const [date, setDate] = useState(false);
  const [month, setMonth] = useState(false);
  const dayRef = useRef(null);
  const monthRef = useRef(null);
  const yearRef = useRef(null);

  const handleChange = async (event) => {
    handleFormStart();
    var name = event.target.name;
    var value = event.target.value;
    let currentErrors = { ...error };

    const fireDataLayerEvent = (eventName) => {
      if (!eventFired[name]) {
        DataLayerEvent("", "", "custom_event", "home_loan_campaign", "land_loan", eventName, true);
        setEventFired({ ...eventFired, [name]: true });
      }
    };

    //Fullname Validation
    if (name === "fullname") {
      fireDataLayerEvent("name_entered");
      value = value.replace(/[^A-Za-z\s]/gi, "");
      if (!value) {
        formIsValid = false;
        currentErrors["fullname"] = "Please enter your full name.";
      } else if (typeof value !== "undefined") {
        // let fullname = inputs.fullname.trim();
        if (!value.match(/^[a-zA-Z ]*$/)) {
          formIsValid = false;
          currentErrors["fullname"] = "Please enter valid full name.";
        } else {
          currentErrors['fullname'] = '';
        }
      }
    }
    //PAN validation
    if (name === "pan") {
      fireDataLayerEvent("pan_number_entered");
      value = value.replace(/\s\s+/g, " ");
      value = value.toUpperCase();
      value = value.replace(/[^a-zA-Z0-9]/g, "");
      if (!value) {
        formIsValid = false;
        currentErrors["pan"] = "Please enter a valid PAN."
      }
      else if (typeof value !== "undefined") {
        if (!value.match(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)) {
          formIsValid = false;
          currentErrors["pan"] = "Please enter a valid PAN."
        } else {
          currentErrors['pan'] = '';
        }
      }
    }

    //Email Validation Start
    if (name === "email") {
      fireDataLayerEvent("email_address_entered");
      if (!value) {
        formIsValid = false;
        currentErrors["email"] = "Please enter your email.";
      }

      else if (typeof value !== "undefined") {
        //regular expression for email validation
        var pattern = new RegExp(
          /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );
        if (!pattern.test(value)) {
          formIsValid = false;
          currentErrors["email"] = "Please enter valid email.";
        } else {
          currentErrors["email"] = '';
        }
      }
    }

    //Mobile Number validation
    if (name === "mobile") {
      fireDataLayerEvent("mob_number_entered");
      if (!value) {
        formIsValid = false;
        currentErrors["mobile"] = "Please enter your mobile number.";
      }
      else if (typeof value !== "undefined") {
        value = value.replace(/^0+/, "");
        if (!value.match(/^[6-9]\d{9}$/)) {
          formIsValid = false;
          currentErrors["mobile"] = "Please enter valid mobile number.";
        } else {
          currentErrors["mobile"] = '';
        }
      }
    }
    //OTP Validation
    if (name === "otp") {
      fireDataLayerEvent("otp_entered");
      if (value.length === 6) {
        setOTP(value);
      }
      if (!value) {
        formIsValid = false;
        currentErrors["otp"] = "Please enter OTP.";
      }
      else if (typeof value !== "undefined" && value.length !== 6) {
        formIsValid = false;
        currentErrors["otp"] = "Please enter valid OTP.";
      } else {
        currentErrors["otp"] = '';
      }
    }
    //Check Field Validation
    if (name === "terms_chk") {
      //Trigger ctaClick event for checkbox field
      ctaClickEvent(`consent checkbox: ${event.target.checked}`, "lead form", "checkbox", 0, "na");
      if (!event.target.checked) {
        formIsValid = false;
        currentErrors["terms_chk"] = "Please accept the terms and conditions.";
      } else {
        currentErrors["terms_chk"] = ''
      }
    }

    //Pincode Validation
    if (name === "pincode") {
      fireDataLayerEvent("property__location_pincode_entered");
      let cityExists;
      setPIN(value);
      if (value.length === 6) {
        setCityname("Fetching...");
        //console.log("get city name here");
        let payload = { pincode: value };
        let param = { type: "pincode" };
        const response = await callLSQLapp(payload, "MAVIS", param);
        const { uniqueArray, filteredCount } = response.data.message;
        // console.log("city", filteredCount > 0);
        if (filteredCount > 0) {
          cityExists = true;
          var CityNameIs = uniqueArray[0].District;
          console.log("cityName is", CityNameIs);
          setCityname(CityNameIs);
          setCitydefined(true);
          currentErrors["pincode"] = "";
        } else {
          cityExists = false;
          currentErrors["pincode"] = "Please enter valid pincode.";
          setCityname("City not found.");
          setCitydefined(false);
        }
      }
      inputs.pincode = value;
      inputs.CityName = CityNameIs;
      if (!value) {
        formIsValid = false;
        currentErrors["pincode"] = "Please enter pincode.";
      }
      else if (value && !value.match(/^[1-9][0-9]{5}$/)) {
        formIsValid = false;
        currentErrors["pincode"] = "Please enter valid pincode.";
      }
      else if (value && value.match(/^[1-9][0-9]{5}$/) && !cityExists) {
        formIsValid = false;
        currentErrors["pincode"] = "Please enter valid pincode.";
      }
      else {
        currentErrors["pincode"] = ''
      }
    }

    // Date validate date and change focus
    if (name === "dob") {
      if (value.length === 2 && value === "00") {
        value = "";
        setDate(value);
      }
      if (value.length === 1 && value >= 1 && value <= 3) {
        setDate(value);
      } else if (value.length === 1 && value >= 4 && value <= 9) {
        setDate("0" + value);
        monthRef.current.focus();
      } else if (value.length === 2 && value >= 10 && value <= 31) {
        setDate(value);
        monthRef.current.focus();
      } else if (value >= 32) {
        setDate(value.slice(0, 1));
      } else {
        setDate(value);
      }
    }

    // Month validate date and change focus
    if (name === "dob_month") {
      if (value.length === 1 && value === 1) {
        setMonth(value);
      } else if (value.length === 1 && value >= 2 && value <= 9) {
        if (value === 2 && date >= 30) {
          setDate("");
          dayRef.current.focus();
        } else {
          yearRef.current.focus();
        }
        setMonth("0" + value);
      } else if (value.length === 2 && value >= 10 && value <= 12) {
        setMonth(value);
        yearRef.current.focus();
      } else if (value >= 13) {
        setMonth(value.slice(0, 1));
      } else {
        setMonth(value);
      }
    }

    // Year validate date and change focus
    if (name === "dob_month") {
      if (date >= 1 && date <= 3 && date.length === 1) {
        setDate("0" + date);
      }
      if (value.length === 2 && value === "00") {
        value = "";
        setMonth(value);
      }
      if (value.length === 1 && value === 1) {
        setMonth(value);
      } else if (value.length === 1 && value >= 2 && value <= 9) {
        setMonth("0" + value);
        yearRef.current.focus();
      } else if (value.length === 2 && value >= 10 && value <= 12) {
        setMonth(value);
        yearRef.current.focus();
      } else if (value >= 13) {
        setMonth(value.slice(0, 1));
      } else {
        setMonth(value);
      }
    }

    if (name === "dob_year") {
      if (value.length === 1 && value === "0") {
        value = "";
      }

      let year = new Date().getFullYear() - 15;
      let yearStart = new Date().getFullYear() - 100;
      if (value.length === 4 && value > year) {
        value = "";
      }
      if (value.length === 4 && value < yearStart) {
        value = "";
      }
      if (date >= 1 && date <= 3 && date.length === 1) {
        setDate("0" + date);
      }

      if (month >= 1 && month <= 9 && month.length === 1) {
        setMonth("0" + month);
      }
    }

    //DOB Validation Start
    if (name === "dob") {
      fireDataLayerEvent("dob_entered");
      if (!value) {
        formIsValid = false;
        currentErrors["dob"] = "Please enter your Date Of Birth.";
      }

      if (typeof value !== "undefined") {
        if (!(value >= 1 && value <= 31)) {
          formIsValid = false;
          currentErrors["dob"] = "Please enter valid Date Of Birth.";
        } else {
          currentErrors["dob"] = "";
        }
      }
    }

    if (name === "dob_month") {
      if (!value) {
        formIsValid = false;
        currentErrors["dob"] = "Please enter your Date Of Birth.";
      }
      if (typeof value !== "undefined") {
        if (!(value >= 1 && value <= 12)) {
          formIsValid = false;
          currentErrors["dob"] = "Please enter valid Date Of Birth.";
        } else {
          currentErrors["dob"] = "";
        }
      }
    }

    if (name === "dob_year") {
      if (!value) {
        formIsValid = false;
        currentErrors["dob"] = "Please enter your Date Of Birth.";
      }
      // Minimum age to take loan is 25
      if (typeof value !== "undefined") {
        let year = new Date().getFullYear() - 21;
        let yearStart = new Date().getFullYear() - 65;

        if (value < yearStart) {
          formIsValid = false;
          currentErrors["dob"] = "Age must be less than 65 years.";
        }
        if (value >= year) {
          formIsValid = false;
          currentErrors["dob"] = "Age must be greater than or equal to 21 years.";
        }

        if (value > yearStart && value < year) {
          currentErrors["dob"] = "";
        }
      }
    }

    setErrors(currentErrors);
    setSpaceTwo(true);
    setInputs((inputs) => ({ ...inputs, [name]: value }));

  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    const currentErrorss = { ...error };
    //Personal details validations
    //PAN validation
    if (!inputs["pan"]) {
      formIsValid = false;
      currentErrorss["pan"] = "Please enter a valid PAN."
    }
    if (typeof inputs["pan"] !== "undefined") {
      if (!inputs["pan"].match(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)) {
        formIsValid = false;
        currentErrorss["pan"] = "Please enter a valid PAN."
      }
    }
    //Fullname Validation Start
    if (!inputs["fullname"]) {
      formIsValid = false;
      currentErrorss["fullname"] = "Please enter your fullname.";
    }

    if (typeof inputs["fullname"] !== "undefined") {
      // let fullname = inputs.fullname.trim();
      if (!inputs["fullname"].match(/^[a-zA-Z ]*$/)) {
        formIsValid = false;
        currentErrorss["fullname"] = "Please enter valid full name.";
      }
    }

    //Email Validation Start
    if (!inputs["email"]) {
      formIsValid = false;
      currentErrorss["email"] = "Please enter your email.";
    }

    if (typeof inputs["email"] !== "undefined") {
      //regular expression for email validation
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(inputs["email"])) {
        formIsValid = false;
        currentErrorss["email"] = "Please enter valid email.";
      }
    }

    if (!inputs["mobile"]) {
      formIsValid = false;
      currentErrorss["mobile"] = "Please enter your mobile number.";
    }

    if (typeof inputs["mobile"] !== "undefined") {
      inputs["mobile"] = inputs["mobile"].replace(/^0+/, "");
      if (!inputs["mobile"].match(/^[6-9]\d{9}$/)) {
        formIsValid = false;
        currentErrorss["mobile"] = "Please enter valid mobile number.";
      }
    }

    if (typeof inputs["mobile"] !== "undefined") {
      inputs["mobile"] = inputs["mobile"].replace(/^0+/, "");
      if (!inputs["mobile"].match(/^[6-9]\d{9}$/)) {
        formIsValid = false;
        currentErrorss["mobile"] = "Please enter valid mobile number.";
      }
    }

    if (!inputs["otp"]) {
      formIsValid = false;
      currentErrorss["otp"] = "Please enter OTP.";
    }

    if (typeof inputs["otp"] !== "undefined" && inputs["otp"].length !== 6) {
      formIsValid = false;
      currentErrorss["otp"] = "Please enter valid OTP.";
    }
    if (typeof inputs["otp"] !== "undefined" && inputs["otp"].length === 6 && error.otp) {
      formIsValid = false;
      currentErrorss["otp"] = "Please enter valid OTP.";
    }

    if (!checked) {
      formIsValid = false;
      currentErrorss["terms_chk"] = "Please accept the terms and conditions.";
    }

    if (displayRecap && recaptchaValue.length === 0) {
      return;
    }

    if (!inputs["pincode"] && !citydefined) {
      formIsValid = false;
      currentErrorss["pincode"] = "Please enter pincode.";
    }

    if (inputs["pincode"] && !inputs["pincode"].match(/^[1-9][0-9]{5}$/)) {
      if (!citydefined) {
        formIsValid = false;
        currentErrorss["pincode"] = "Please enter valid pincode.";
      }
    }
    //DOB Validation Start
    if (!inputs["dob"] || !inputs["dob_month"] || !inputs["dob_year"]) {
      formIsValid = false;
      currentErrorss["dob"] = "Please enter your Date Of Birth.";
    }

    if (typeof inputs["dob"] !== "undefined") {
      if (!(inputs["dob"] >= 1 && inputs["dob"] <= 31)) {
        formIsValid = false;
        currentErrorss["dob"] = "Please enter valid Date Of Birth.";
      }
    }

    if (typeof inputs["dob_month"] !== "undefined") {
      if (!(inputs["dob_month"] >= 1 && inputs["dob_month"] <= 12)) {
        formIsValid = false;
        currentErrorss["dob"] = "Please enter valid Date Of Birth.";
      }
    }

    // Minimum age to take loan is 25
    if (typeof inputs["dob_year"] !== "undefined") {
      let year = new Date().getFullYear() - 21;
      let yearStart = new Date().getFullYear() - 65;

      if (inputs["dob_year"] < yearStart) {
        formIsValid = false;
        currentErrorss["dob"] = "Please enter valid year.";
      }

      if (inputs["dob_year"] >= year) {
        formIsValid = false;
        currentErrorss["dob"] = "Please enter valid year.";
      }
    }
    setErrors(currentErrorss);
    setSpaceTwo(true);

    if (formIsValid) {
      setSpaceTwo(false);
      setApplyBtnDisable(true);
      const utmParamsObj = queryString.parse(window.location.search);
      for (const [key, value] of Object.entries(utmParamsObj)) {
        inputs[key] = value;
      }
      // inputs.subProduct = "Land Loan";
      inputs.ApiProductName = "Land Loan";
      // inputs.UserName = "homeloan";
      // inputs.Password = "homeloan";
      // inputs.ApiCompanyName = "internal";
      inputs.ParentProduct = "Home Loan";
      inputs.ModeOfLead = "landing-page";
      inputs.DeviceType = "";
      inputs.CostOfProperty = "";
      inputs.CampaignId = "832999";
      if (checked) {
        inputs.DND = "Yes";
        inputs.terms_chk = true;
      } else {
        inputs.DND = "No";
        inputs.terms_chk = false;
      }
      inputs.token = token;
      var year = inputs.dob_year;
      var month = inputs.dob_month;
      var day = inputs.dob;
      // console.log( year,month,day )
      // if day and month value is less than 10 adding 0 before it. Eg: 2 (02)
      let dayFormated = ("0" + day).slice(-2);
      let monthFormated = ("0" + month).slice(-2);

      // dob in YYYY-MM-DD format
      let dateofbirthIs = `${year}-${monthFormated}-${dayFormated}`;

      inputs.DateOfBirthValue = dateofbirthIs;

      inputs.Age = Math.floor(
        (new Date().getTime() - new Date(inputs.DateOfBirthValue).getTime()) /
        (3600 * 1000 * 365 * 24)
      );
      inputs.IsEligible = "Yes";
      inputs.EligibilityReason = "";
      inputs.CompleteUrl = window.location.href;
      inputs.User_Agent = navigator.userAgent;

      await setValuesInLocalStorange(inputs["email"], inputs["mobile"]);

      let payload = {
        mobile: inputs.mobile,
        otp: inputs.otp,
        formdata: getLsqLeadBody(inputs),
      };
      // console.log("Lead Create Payload", payload);

      //Encrypt Payload
      const encryptedPayload = await encryptBody(payload);
      // console.log("Lead Create encrypted Payload", encryptedPayload);
      let param = { productType: "LL" };

      let createLeadResp = await callLSQLapp(encryptedPayload, "CREATE", param);

      if (
        createLeadResp.data.message !== "Failure occured , please check logs"
      ) {
        let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;
        console.log("leadID", leadid);
        //Trigger AA formSuccess event
        formSuccessEvent("Land Loan lead form", { otp: inputs.otp, pincode: inputs.pincode, city: inputs.CityName }, "lead generation", "thank you", true);
        navigate(`/thankyou?id=${leadid}`);
      } else {
        setApplyBtnDisable(false);
        //Trigger AA formSubmissionFail event
        formSubmissionFailEvent();
        console.log("lead not created.");
      }
    } else {
      //Trigger AA formFieldError event
      formFieldErrorEvent(currentErrorss);
    }
  };

  const handleFormStart = () => {
    if (!hasTriggeredFormStart.current) {
      formStartEvent("Land Loan lead form", "lead generation", "details");
      hasTriggeredFormStart.current = true;
    }
  };

  return (
    <article
      className={`banner_sec position-relative ${space ? "m_update" : null} ${spaceTwo ? "m_update_two" : null
        }`}
    >
      <div className="banner_img">
        <picture>
          {/* <source rel="preload"  media="(max-width: 767px)" srcset="./dist/img/banner_mobile.webp" type="image/webp"> */}
          <source
            rel="preload"
            media="(max-width:767.5px)"
            srcSet="./dist/img/land_loan_mobile.png"
            alt="ICICI Bank Home Loan Banner"
            width={767}
            height={271}
          />
          {/* <source rel="preload"  srcset="./dist/img/banner_mobile.webp" type="image/webp"> */}
          <img
            rel="preload"
            src="./dist/img/land_loan_desktop.png"
            alt="Banner img"
            width={1920}
            height={765}
            className="img-fluid"
          />
        </picture>
        {/* <div className="bannerHeading">
          <p>
            Get Land Loan to build your future
          </p>
        </div> */}
      </div>

      {/* <ul className="d-none d-none d-md-inline-flex"> */}
      {/* <li>
          <div className="banner_content_img">
            <img
              src="./dist/img/easy_doc_process.webp"
              alt="ICICI Bank"
              className="img-fluid"
              height={104}
              width={100}
            />
          </div>
          <h2>
            Easy Documentation <br /> Process
          </h2>
        </li> */}
      {/* <li>
          <div className="banner_content_img">
            <img
              src="./dist/img/fast_loan_process.webp"
              alt="ICICI Bank"
              className="img-fluid"
              height={104}
              width={100}
            />
          </div>
          <h2>
            Fast Loan <br /> Process
          </h2>
        </li> */}
      {/* <li>
          <div className="banner_content_img">
            <img
              src="./dist/img/higher_loan.webp"
              alt="ICICI Bank"
              className="img-fluid"
              height={104}
              width={100}
            />
          </div>
          <h2>
            Higher Loan <br /> Amount
          </h2>
        </li> */}
      {/* </ul> */}
      {/* <div className="banner_headings d-inline-flex d-md-none">
        <ul className="headingul">
          <li>
            <h2>Easy Documentation Process</h2>
          </li>
          <li>
            <h2>
              Fast Loan <br /> Process
            </h2>
          </li>
          <li>
            <h2>
              Higher Loan <br /> Amount
            </h2>
          </li>
        </ul>
      </div> */}
      {/* form */}
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-12">
            <div className="form_wrap" id="land_loan">
              <div className="form_heading">
                <h4>
                  Apply now to get land loan
                </h4>
              </div>
              <form name="contactForm" method="post" onSubmit={handleSubmit}>
                <section className="personal-details">
                  <div className="col-12 my-2">
                    <input
                      type="text"
                      name="fullname"
                      placeholder="Name"
                      id="name"
                      onChange={handleChange}
                      value={
                        inputs.fullname
                          ? inputs.fullname.replace(/[^a-z ]/gi, "")
                          : ""
                      }
                    />
                  </div>
                  <span className="error" id="day_error">
                    {error.fullname}
                  </span>
                  <div className="my-2">
                    <input
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Email"
                      onChange={handleChange}
                    />
                  </div>
                  <span className="error" id="day_error">
                    {error.email}
                  </span>
                  <div
                    className="birth_date_detail form-group"
                    id="birth_date_detail_id"
                  >
                    <div className="label_and_input">
                      <label>Date Of Birth</label>
                      <div id="dateofbirth">
                        <div className="dob">
                          <input
                            type="number"
                            className="input-text-field w-input dobfield criffCall"
                            name="dob"
                            placeholder="DD"
                            id="dob_day"
                            required=""
                            ref={dayRef}
                            value={date}
                            onInput={(e) =>
                              (e.target.value = e.target.value.slice(0, 2))
                            }
                            onChange={handleChange}
                          />
                          <div className="input-hr-spacer"></div>
                          <input
                            type="number"
                            className="input-text-field w-input dobfield criffCall"
                            name="dob_month"
                            placeholder="MM"
                            id="dob_month"
                            ref={monthRef}
                            value={month}
                            required=""
                            onInput={(e) =>
                              (e.target.value = e.target.value.slice(0, 2))
                            }
                            onChange={handleChange}
                          />
                          <div className="input-hr-spacer"></div>
                          <input
                            type="number"
                            className="input-text-field w-input dobfield criffCall"
                            name="dob_year"
                            data-name="dob_year"
                            placeholder="YYYY"
                            id="dob_year"
                            ref={yearRef}
                            required=""
                            onInput={(e) =>
                              (e.target.value = e.target.value.slice(0, 4))
                            }
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <span className="error" id="day_error">
                    {error.dob}
                  </span>
                  <div className="my-2">
                    <div className="form-control-wrap icons text-field-with-icon position-relative">
                      <span className="text-icon number-span">+91 </span>
                      <input
                        type="number"
                        name="mobile"
                        placeholder="Mobile Number"
                        pattern="\d{10}"
                        id="mobile_number"
                        style={{ textAlign: "left", paddingLeft: "40px" }}
                        value={
                          inputs.mobile > 0
                            ? inputs.mobile.replace(/^[0-5]+/, "")
                            : ""
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.slice(0, 10))
                        }
                        onChange={handleChange}
                        disabled={disableBtn}
                      />

                      {otpsent && timer <= 0 ? (
                        <button
                          type="button"
                          className="btn"
                          id="resendBtn"
                          onClick={() => sendOTPText(mobileVal, "resend")}
                          style={{ display: resendBtnDisplay }}
                          disabled={otpDisabled}
                        >
                          {otpBtnText}
                        </button>
                      ) : (
                        <span
                          className="Timer"
                          id="timer"
                          style={{ display: timerDisplay }}
                        >
                          {" "}
                          00:
                          {timer.toString().length < 2
                            ? timer.toString().padStart(2, "00")
                            : timer}
                        </span>
                      )}
                    </div>
                  </div>
                  <span className="error" id="day_error">
                    {error.mobile}
                  </span>
                  <div className="form-group my-2">
                    <input
                      type="number"
                      name="otp"
                      placeholder="OTP"
                      id="otp"
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 6))
                      }
                      onChange={handleChange}
                      disabled={otpdisableBtn}
                    />
                  </div>
                  <span className="error" id="day_error">
                    {error.otp}
                  </span>
                  <div
                    className="mb-4"
                    style={{
                      display: displayRecap === true ? "block" : "none",
                    }}
                  >
                    <ReCAPTCHA
                      sitekey={
                        window.location.host === "campaigns.icicibank.com"
                          ? "6LeMtTceAAAAANlK0_mDmUJcqUNsHDCrV5ogVXmn"
                          : "6LeRQnEeAAAAAAJgZz2PnoWITvb3S6tgcGeFdd14"
                      }
                      onChange={onRecaptchaChange}
                    />
                    {recaptchaError && <span className="error" id="day_error">{recaptchaError}</span>}
                  </div>
                  <div className="my-2">
                    <input
                      type="text"
                      name="pan"
                      placeholder="PAN Card Number"
                      id="pan"
                      value={inputs.pan ? inputs.pan : ""}
                      onChange={handleChange}
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 10))
                      }
                    />
                  </div>
                  <span className="error" id="day_error">
                    {error.pan}
                  </span>
                  <div className="location_detail" id="sal_location_detail">
                    <div className="autocomplete">
                      <input
                        className="cityList city_fetch"
                        type="number"
                        placeholder="Property PIN Code"
                        id="sal_pincode"
                        name="pincode"
                        autoComplete="off"
                        // onChange={handleChange}
                        onInput={(e) =>
                          (e.target.value = e.target.value.slice(0, 6))
                        }
                        value={
                          inputs.pincode > 0
                            ? inputs.pincode.replace(/^0+/, "")
                            : inputs.pincode
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <span className="error" id="day_error">
                      {error.pincode}
                    </span>

                    <div>
                      <input
                        className="cityList city_fetch"
                        type="text"
                        placeholder="City (Auto fetch)"
                        id="sal_pincode"
                        name=""
                        autoComplete="off"
                        value={cityName}
                        disabled
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="checkbox row">
                    <div className="col-1 p-0 check-input">
                      <input
                        type="checkbox"
                        name="terms_chk"
                        id="terms_chk"
                        defaultChecked={checked}
                        onClick={() => setChecked(!checked)}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-11 p-0 ">
                      <label htmlFor="terms_chk" className="MIT">
                        I agree to be bound by these{" "}
                        <a
                          target="_blank"
                          href="https://www.icicibank.com/terms-condition?_ga=2.59170351.365826006.1680849363-894239963.1678362457"
                          onClick={() => { handleFormStart(); ctaClickEvent("terms & conditions", "lead form", "text link", 0, "https://www.icicibank.com/terms-condition?_ga=2.59170351.365826006.1680849363-894239963.1678362457"); }}
                          onContextMenu={() => { handleFormStart(); ctaClickEvent("terms & conditions", "lead form", "text link", 0, "https://www.icicibank.com/terms-condition?_ga=2.59170351.365826006.1680849363-894239963.1678362457"); }}
                        >
                          {" "}
                          Terms & Conditions{" "}
                        </a>{" "}
                        and{" "}
                        <Button
                          variant="primary"
                          className="MIT"
                          onClick={() => { setModalShow(true); handleFormStart(); ctaClickEvent("open: Most Important Terms & Conditions", "lead form", "text link", 0, "na"); }}
                        >
                          Most Important Terms & Conditions
                        </Button>
                        {" "}
                        <MyVerticallyCenteredModal
                          show={modalShow}
                          onHide={() => { setModalShow(false); ctaClickEvent("close: Most Important Terms & Conditions", "popup", "icon or button", 0, "na"); }}
                        />
                        prescribed by ICICI Bank Limited. I permit ICICI Bank Limited to share my contact details with ICICI Home Finance Company. Further, I specifically permit representatives from ICICI Bank Limited & ICICI Home Finance Company to reach out to me through my registered e-mail, phone, SMS, WhatsApp messaging, or any other electronic mode or other messaging or social media platforms in relation to my home loan application.
                      </label>
                    </div>
                    <span className="error" id="day_error">
                      {error.terms_chk}
                    </span>
                  </div>


                  <div className="applynow">
                    <input
                      type="submit"
                      name="form-submitF"
                      value="Apply Now"
                      className="next_btn"
                      id="nxt_btnsubmit"
                      onChange={handleChange}
                      onClick={() => {
                        handleFormStart();
                        if (!eventFired["applyNow"]) {
                          DataLayerEvent("", "", "custom_event", "home_loan_campaign", "land_loan", "apply_clicked", true);
                          setEventFired({ ...eventFired, applyNow: true });
                        }
                      }}
                      disabled={disableApplyBtn}
                    />
                  </div>
                </section>
              </form>
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
    </article >
  );
}

export default Form;
